import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Percent, Calculator } from 'lucide-react';

const MotionCard = motion(Card);

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
  hover: { 
    scale: 1.05,
    transition: { duration: 0.2 }
  }
};

const Interest = () => {
  const calculators = [
    {
      title: 'Find Future Value',
      description: 'Find the future value of an investment of $10,000 at 5.00% interest compounded Yearly for 10 years.',
      icon: <Calculator className="w-8 h-8 text-blue-500" />,
      link: '/calculators/future-value',
      color: 'from-blue-400 to-blue-600'
    },
    {
      title: 'Compound Interest Calculator',
      description: 'Determine how an investment grows over time with compound interest.',
      icon: <Percent className="w-8 h-8 text-green-500" />,
      link: '/calculators/compound-interest',
      color: 'from-green-400 to-green-600'
    }
  ];

  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <h1 className="text-3xl font-bold mb-8 text-center">Interest Calculators</h1>
      <div className="space-y-8">
        {calculators.map((calculator, index) => (
          <Link to={calculator.link} key={calculator.title}>
            <MotionCard
              className="overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              whileHover="hover"
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <div className={`h-2 bg-gradient-to-r ${calculator.color}`} />
              <CardHeader className="flex flex-row items-center space-x-4 pb-2">
                {calculator.icon}
                <h3 className="text-2xl font-semibold text-gray-800">{calculator.title}</h3>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">{calculator.description}</p>
              </CardContent>
              <div className={`h-2 bg-gradient-to-r ${calculator.color}`} />
            </MotionCard>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Interest;